/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  ChangeEvent,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Grid from '@material-ui/core/Grid';
import { BsTrash } from 'react-icons/bs';

import {
  TabWrapper,
  DrawerTabTitle,
  RadioDisponibilidadeWrapper,
  DisponibilidadeWrapper,
  SelectTurno,
  AddButton,
  ButtonAction,
} from '../../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../../styles';
import material_styles from '../../../../drawer_styles/material_styles';
import { useToast } from '../../../../../../../../hooks/toast';
import { useSimpleProduct } from '../../../../../../../../hooks/newSimpleProduct';
import { useRegisterAdded } from '../../../../../../../../hooks/registerAdded';

import schedulesOptions from '../../../../../../utils/schedulesOptions';

interface TurnoType {
  inicio: number;
  fim: number;
}

interface QtdTurnos {
  index: number;
}

const Disponibilidade: React.FC = () => {
  const {
    disponibilidade,
    turnos,
    qtdTurnos,
    sempreDisponivel,
    handleSetTurnos,
    createDisponibilidade,
    handleSetQtdTurno,
    handleSetSempreDisponivel,
    setFilledData2,
    submit,
  } = useSimpleProduct();
  const { handleSetDrawerWasClosed } = useRegisterAdded();

  const [days, setDays] = useState(disponibilidade.dias);
  const [btnDisable, setBtnDisable] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const classes = material_styles();

  const { addToast } = useToast();

  useEffect(() => {
    setBtnDisable(false);
  }, []);

  const handleChangeTurno = useCallback(
    (e: any, item_index: number, turno: string) => {
      const newTurnoState = [...turnos];

      if (turno === 'inicio') newTurnoState[item_index].inicio = e.value;
      else if (turno === 'fim') newTurnoState[item_index].fim = e.value;

      handleSetTurnos([...newTurnoState]);
    },
    [turnos, handleSetTurnos],
  );

  const handleChangeDay = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const daysUpdated = days;

      switch (value) {
        case 'domingo':
          daysUpdated.domingo = !daysUpdated.domingo;
          break;
        case 'segunda':
          daysUpdated.segunda = !daysUpdated.segunda;
          break;
        case 'terca':
          daysUpdated.terca = !daysUpdated.terca;
          break;
        case 'quarta':
          daysUpdated.quarta = !daysUpdated.quarta;
          break;
        case 'quinta':
          daysUpdated.quinta = !daysUpdated.quinta;
          break;
        case 'sexta':
          daysUpdated.sexta = !daysUpdated.sexta;
          break;
        case 'sabado':
          daysUpdated.sabado = !daysUpdated.sabado;
          break;
        default:
          return;
      }

      createDisponibilidade({
        ...disponibilidade,
        dias: { ...daysUpdated },
      });
      setDays(days);
    },
    [days, disponibilidade, createDisponibilidade],
  );

  const handleSetDisponibilidade = useCallback(
    (invisible: boolean) => {
      handleSetSempreDisponivel(invisible);
    },
    [handleSetSempreDisponivel],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      setBtnDisable(true);
      const keys = Object.entries(data);
      const turnoType: TurnoType[] = [];

      if (sempreDisponivel) {
        createDisponibilidade({
          dias: {
            domingo: true,
            segunda: true,
            terca: true,
            quarta: true,
            quinta: true,
            sexta: true,
            sabado: true,
          },
          turnos: [],
        });
      }

      if (qtdTurnos.length == 0 && !sempreDisponivel) {
        createDisponibilidade({ dias: days, turnos: [] });
      } else if (!sempreDisponivel) {
        for (let i = 0; i < qtdTurnos.length; i += 1) {
          const index = i * 2;

          const inicio = Number(keys[index][1]);
          const fim = Number(keys[index + 1][1]);

          if (inicio > fim) {
            addToast({
              type: 'error',
              title: 'Turno inválido.',
              description: 'O início do turno deve ser maior que o fim',
            });
            setBtnDisable(false);

            return;
          }

          const turnoObjectType: TurnoType = {
            inicio,
            fim,
          };

          turnoType.push(turnoObjectType);
        }
        createDisponibilidade({ dias: days, turnos: [...turnoType] });
      }

      await submit();
      setFilledData2(true);
      addToast({
        type: 'success',
        title: 'Produto criado.',
      });
    },
    [
      qtdTurnos,
      createDisponibilidade,
      days,
      sempreDisponivel,
      setFilledData2,
      addToast,
    ],
  );

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Disponibilidade</h1>
        <span>
          Defina os momentos em que os clientes poderão comprar este item.
        </span>
      </DrawerTabTitle>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.noPaddingBot}>
            <RadioDisponibilidadeWrapper>
              <form>
                <div>
                  <label htmlFor="no_have">
                    <input
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      checked={sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(true)}
                    />
                    Sempre Disponível
                  </label>
                  <span>
                    O item ficará disponível sempre que o restaurante estiver
                    aberto
                  </span>
                </div>

                <div>
                  <label htmlFor="have">
                    <input
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      checked={!sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(false)}
                    />
                    Disponível em dias e horários específicos
                  </label>
                  <span>Selecione os dias que o item estará disponível</span>
                </div>
              </form>
            </RadioDisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingTop}>
            <DisponibilidadeWrapper isInvisible={sempreDisponivel}>
              <div className="dias">
                <span>Dias da Semana</span>

                <input
                  type="checkbox"
                  id="domingo"
                  name="domingo"
                  value="domingo"
                  onChange={handleChangeDay}
                  checked={days.domingo}
                />
                <label htmlFor="domingo">D</label>

                <input
                  type="checkbox"
                  id="segunda"
                  name="segunda"
                  value="segunda"
                  onChange={handleChangeDay}
                  checked={days.segunda}
                />
                <label htmlFor="segunda">S</label>

                <input
                  type="checkbox"
                  id="terca"
                  name="terca"
                  value="terca"
                  onChange={handleChangeDay}
                  checked={days.terca}
                />
                <label htmlFor="terca">T</label>

                <input
                  type="checkbox"
                  id="quarta"
                  name="quarta"
                  value="quarta"
                  onChange={handleChangeDay}
                  checked={days.quarta}
                />
                <label htmlFor="quarta">Q</label>

                <input
                  type="checkbox"
                  id="quinta"
                  name="quinta"
                  value="quinta"
                  onChange={handleChangeDay}
                  checked={days.quinta}
                />
                <label htmlFor="quinta">Q</label>

                <input
                  type="checkbox"
                  id="sexta"
                  name="sexta"
                  value="sexta"
                  onChange={handleChangeDay}
                  checked={days.sexta}
                />
                <label htmlFor="sexta">S</label>

                <input
                  type="checkbox"
                  id="sabado"
                  name="sabado"
                  value="sabado"
                  onChange={handleChangeDay}
                  checked={days.sabado}
                />
                <label htmlFor="sabado">S</label>
              </div>

              <div className="turno_wrapper">
                <div className="title_wrapper">
                  <span>Horários</span>
                  <AddButton
                    type="button"
                    onClick={() => handleSetQtdTurno('add')}
                  >
                    + Adicionar Turno
                  </AddButton>
                </div>

                {qtdTurnos.map((item) => (
                  <div className="turnos_wrapper">
                    <div className="turno">
                      <span>{`${item.index + 1}º Turno`}</span>
                      <SelectTurno
                        name={`${item.index}turno_inicio`}
                        placeholder="Selecione"
                        options={schedulesOptions}
                        value={{
                          label: turnos[item.index].inicio.toString(),
                          value: turnos[item.index].inicio,
                        }}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          handleChangeTurno(e, item.index, 'inicio')
                        }
                      />
                      <SelectTurno
                        name={`${item.index}turno_fim`}
                        placeholder="Selecione"
                        options={schedulesOptions}
                        value={{
                          label: turnos[item.index].fim.toString(),
                          value: turnos[item.index].fim,
                        }}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          handleChangeTurno(e, item.index, 'fim')
                        }
                      />

                      <button
                        type="button"
                        onClick={() => handleSetQtdTurno('remove')}
                      >
                        <BsTrash size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </DisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingBot}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={() => handleSetDrawerWasClosed(true)}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                disabled={btnDisable}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Disponibilidade;
